<template>
  <div>
    <SidebarTitle class="mb-2" icon="HexagonIcon" title="related areas" :plus="emptyValue && !pickerVisible" @plusClicked="pickerVisible = true"/>
    <div v-if="pickerVisible" class="mt-2">
      <div class="flex mb-8 justify-evenly">
        <Checkbox :key="`${$vnode.key}-health`" :namespace="`${$vnode.key}-health`" class="p-0" initValue="health" title="health" icon="ActivityIcon" v-model="localValue" />
        <Checkbox :key="`${$vnode.key}-play`" :namespace="`${$vnode.key}-play`" class="p-0" initValue="play" title="play" icon="UsersIcon" v-model="localValue" />
        <Checkbox :key="`${$vnode.key}-spirituality`" :namespace="`${$vnode.key}-spirituality`" class="p-0" initValue="spirituality" title="spirituality" icon="SunriseIcon" v-model="localValue" />
        <Checkbox :key="`${$vnode.key}-enviroment`" :namespace="`${$vnode.key}-enviroment`" class="p-0" initValue="enviroment" title="environment" icon="ImageIcon" v-model="localValue" />
      </div>

      <div class="flex mb-8 justify-evenly">

        <Checkbox :key="`${$vnode.key}-work`" :namespace="`${$vnode.key}-work`" class="p-0" initValue="work" title="work" icon="BriefcaseIcon" v-model="localValue" />
        <Checkbox :key="`${$vnode.key}-wealth`" :namespace="`${$vnode.key}-wealth`" class="p-0" initValue="wealth" title="wealth" icon="DollarSignIcon" v-model="localValue" />
        <Checkbox :key="`${$vnode.key}-growth`" :namespace="`${$vnode.key}-growth`" class="p-0" initValue="growth" title="growth" icon="BookIcon" v-model="localValue" />

        <Checkbox :key="`${$vnode.key}-relationships`" :namespace="`${$vnode.key}-relationships`" class="p-0" initValue="relationships" title="relationships" icon="HeartIcon" v-model="localValue" />
      </div>
    </div>

    <div v-else-if="anyValue" class="flex justify-center text-dark items-center" :class="actionElementCss" @click="pickerVisible = true">

      <LifeArea v-for="lifeArea in localValue" :lifeArea="lifeArea" class="mr-1" :showIcon="true" :hideText="true"/>
      <feather-icon  icon="EditIcon" class="ml-2 w-4" />
    </div>

  </div>
</template>
<script>
import _ from 'lodash'
import Checkbox from '../Onboarding/Wizard/Checkbox'
import LifeArea from './../Stories/LifeArea'

export default {
  components: {
    Checkbox,
    LifeArea
  },
  props: ['value'],
  data () {
    return {
      localValue: null,
      pickerVisible: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.localValue = value
      }
    },
    localValue: {
      immediate: false,
      handler (localValue) {
        this.$emit('input', localValue)

        if (window.smartlook) {
          window.smartlook('track', 'relatedAreas', { userId: this.$store.getters.userId })
        }
      }
    }
  },
  computed: {
    anyValue () {
      return !this.emptyValue
    },
    emptyValue () {
      return _.isEmpty(this.localValue)
    },
  },
  methods: {
    generateName (color) {
      return `${color}-${this.namespace}`
    }

  }
}
</script>


<style>
</style>
